import { create } from 'zustand';

/**
 * Native-only app lock. When the 30-minute inactivity window elapses inside
 * the Android app, the session stays alive server-side but the UI locks
 * behind a re-auth screen (CLAUDE.md session rules; android-app-plan §4.3).
 * For M1 the unlock is password re-entry; M4.1 upgrades it to biometric.
 *
 * Web never sets `isLocked` — inactivity logs the user out instead.
 */
interface AppLockState {
  isLocked: boolean;
  lock: () => void;
  unlock: () => void;
}

export const useAppLockStore = create<AppLockState>((set) => ({
  isLocked: false,
  lock: () => set({ isLocked: true }),
  unlock: () => set({ isLocked: false }),
}));
